import { SENTRY_CONFIG } from '@fukuri-admins/constants/common';
import * as Sentry from '@sentry/react';

/**
 * v10 の `sendDefaultPii: false` が除外していた PII 系のキー（v10 の `PII_HEADER_SNIPPETS`）。
 * v11 の SDK から無くなったため、同じ値をここに持つ。
 * 認証系のキー（`auth` / `token` / `cookie` 等）は、この指定とは別に SDK が常に `[Filtered]` にする。
 */
const PII_KEY_SNIPPETS = ['forwarded', '-ip', 'remote-', 'via', '-user'];

Sentry.init({
  dsn: SENTRY_CONFIG.dsn,
  environment: SENTRY_CONFIG.environment,
  release: SENTRY_CONFIG.release,

  // パフォーマンス設定
  tracesSampleRate: 0.1,
  // pageload / navigation をトランザクションイベントとして送る（既定の 'stream' は span 単位で逐次送る）
  traceLifecycle: 'static',

  // セッションリプレイ設定
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // 最小構成（APIエラー監視）
  // bfcache（戻る / 進む）から復帰したときに navigation トランザクションを作らない
  integrations: [Sentry.browserTracingIntegration({ instrumentBfcacheRestore: false })],

  // 開発環境設定
  debug: false,

  // アプリ識別
  initialScope: {
    tags: {
      app: 'partner-admin',
    },
  },

  // セキュリティ設定（収集するデータの範囲。省略すると全項目を収集する）
  dataCollection: {
    userInfo: false,
    cookies: { deny: PII_KEY_SNIPPETS },
    httpHeaders: { deny: PII_KEY_SNIPPETS },
    httpBodies: [],
    urlQueryParams: { deny: PII_KEY_SNIPPETS },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
  },
});

declare global {
  interface Window {
    testSentryError?: () => void;
  }
}

// 開発環境でのテスト用
if (import.meta.env.DEV) {
  console.log('✅ Sentry initialized for PARTNER-ADMIN app');
  window.testSentryError = () => {
    Sentry.captureException(new Error('Test error from partner-admin app'));
    console.log('🚀 Test error sent to Sentry dashboard');
  };
}
